<div class="active-session-limit-reached-conatiner display-flex-column justify-center align-items-center">
    <div class="font-22 font-bold">Active Session Limit Reached</div>

    <div class="font-16 text-center"> Only one active session is allowed. Logging in here will log out your previous session. </div>

    <div class="font-bold font-16">
        Previous Active Session Details
    </div>
    <div class="display-flex align-items-center border-gray padding gap-16 border-radius-16">
        <div> 
            <img [src]="browserImage" alt="browser">
        </div>
        <div class="center-label font-12 gap-4">
            <div class="font-16 font-bold">
                {{lastSessionDetails?.device}}
            </div>
            <div class="placeholder-text">
                Last Login : {{lastSessionDetails?.login_date| istDate : SESSION_LIMIT_FORMAT : true }}
            </div>
        </div>
    </div>

    <div class="font-bold font-16">Do you want to Proceed ?</div>

    <div class="proceed-btn width-80">
        <button mat-raised-button color="accent" class="full-width pad-4-vr" (click)="proceed()">Proceed Anyway</button>
    </div>
    <div class="cancel-btn width-80">
        <button mat-button class="full-width pad-4-vr" (click)="cancel()">Cancel</button>
    </div>
</div>